import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAppId } from "../context/AppIdContext";
import '../style/login.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const LoginWithOTP = () => {
    // --- State & Logic ---
    const [step, setStep] = useState(1);
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [mobileError, setMobileError] = useState("");

    // Data State
    const [userList, setUserList] = useState([]);

    // 🔴 New Grouped Users State
    const [groupedUsers, setGroupedUsers] = useState({});
    const [finalUser, setFinalUser] = useState(null);

    const navigate = useNavigate();

    // Get context setters
    const {
        setAppId,
        setUserName,
        setUserPhoto,
        setUserId,
        setTotalVoters,
        language,
        setIsAuthenticated,
        setMobileNo,
        // Additional fields to store
        setVidhanSabhaNo,
        setVidhanSabhaName,
        setCandidateNo,
        setCandidateName,
        setPartyShortName,
        setPartyFullName,
        setPartyLogoPng,
        setPartyLogoJpg,
        setSlipMessage,
        setSmsSlipMessage,
        setOfflineStatus,
        setOfflineDbUrl,
        setOfflineVer,
        setSplaceUrl,
        setAppLink,
        setVideoLink,
        setAppVer,
        setBoothNo,
        setTempStatus,
        setPopupStatus,
        setPopupUrl,
        setCallCenter,
        setPrachar,
        setAacharSahita,
        setLiveVoting,
        setSleepSend,
        setMetaWtsp,
        setWhtspApi,
        setAi,
        setAppClose,
        setWtspDeviceId
    } = useAppId();

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            login: "Login",
            enterMobile: "Enter your mobile number to continue.",
            mobileNumber: "Mobile Number",
            mobilePlaceholder: "10-digit number",
            sendOTP: "Send OTP",
            sending: "Sending...",
            enterCode: "Enter code sent to +91 {mobile}",
            verifyLogin: "Verify & Login",
            verifying: "Verifying...",
            changeNumber: "Change number",
            selectVidhanSabha: "Select Ward No",
            rmcTitle: "Select Organization",
            wardNo: "Ward No",
            vidhanSabha: "Vidhan Sabha :",
            continue: "Continue",
            selectResponsibility: "Select Responsibility",
            back: "Back",
            admin: "Admin",
            subAdmin: "Sub Admin",
            volunteer: "Volunteer",
            boothPramukh: "Booth Pramukh",
            sahBoothPramukh: "Sah Booth Pramukh",
            validMobile: "Please enter a valid 10-digit mobile number",
            invalidNumber: "Invalid Number",
            serverError: "Server Error",
            enterOTP: "Please enter the OTP",
            invalidOTP: "Invalid OTP",
            noAccount: "No account found for this number.",
            verificationFailed: "Verification Failed",
            otpSent: "OTP sent successfully",
            mobileRequired: "Mobile number is required",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)",
            warCaptain: "War Captain",
            boothCaptain: "Booth Captain",
            liveVottingUser: "Live Voting User",
            callSurveyUser: "Call Survey User",
            voterCaptain: "Voter Captain"
        },
        hi: {
            login: "लॉगिन",
            enterMobile: "जारी रखने के लिए अपना मोबाइल नंबर दर्ज करें।",
            mobileNumber: "मोबाइल नंबर",
            mobilePlaceholder: "10-अंकीय संख्या",
            sendOTP: "ओटीपी भेजें",
            sending: "भेजा जा रहा है...",
            enterCode: "+91 {mobile} पर भेजा गया कोड दर्ज करें",
            verifyLogin: "सत्यापित करें और लॉगिन करें",
            verifying: "सत्यापित किया जा रहा है...",
            changeNumber: "नंबर बदलें",
            selectVidhanSabha: "वार्ड नंबर चुनें",
            rmcTitle: "संगठन चुनें",
            wardNo: "वार्ड नंबर",
            vidhanSabha: "विधानसभा :",
            continue: "जारी रखें",
            selectResponsibility: "जिम्मेदारी चुनें",
            back: "वापस",
            admin: "एडमिन",
            subAdmin: "सब एडमिन",
            volunteer: "कार्यकर्ता",
            boothPramukh: "बूथ प्रमुख",
            sahBoothPramukh: "सह बूथ प्रमुख",
            validMobile: "कृपया एक वैध 10-अंकीय मोबाइल नंबर दर्ज करें",
            invalidNumber: "अमान्य नंबर",
            serverError: "सर्वर त्रुटि",
            enterOTP: "कृपया ओटीपी दर्ज करें",
            invalidOTP: "अमान्य ओटीपी",
            noAccount: "इस नंबर के लिए कोई खाता नहीं मिला।",
            verificationFailed: "सत्यापन विफल",
            otpSent: "ओटीपी सफलतापूर्वक भेजा गया",
            mobileRequired: "मोबाइल नंबर आवश्यक है",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)",
            warCaptain: "वॉर कैप्टन",
            boothCaptain: "बूथ कैप्टन",
            liveVottingUser: "लाइव वोटिंग उपयोगकर्ता",
            callSurveyUser: "कॉल सर्वे उपयोगकर्ता",
            voterCaptain: "वोटर कैप्टन"
        },
        gu: {
            login: "લૉગિન",
            enterMobile: "ચાલુ રાખવા માટે તમારો મોબાઇલ નંબર દાખલ કરો.",
            mobileNumber: "મોબાઇલ નંબર",
            mobilePlaceholder: "10-અંકનો નંબર",
            sendOTP: "OTP મોકલો",
            sending: "મોકલાઈ રહ્યું છે...",
            enterCode: "+91 {mobile} પર મોકલેલ કોડ દાખલ કરો",
            verifyLogin: "ચકાસો અને લૉગિન કરો",
            verifying: "ચકાસાઈ રહ્યું છે...",
            changeNumber: "નંબર બદલો",
            selectVidhanSabha: "વોર્ડ નંબર પસંદ કરો",
            rmcTitle: "સંગઠન પસંદ કરો",
            wardNo: "વોર્ડ નંબર",
            vidhanSabha: "વિધાનસભા :",
            continue: "ચાલુ રાખો",
            selectResponsibility: "જવાબદારી પસંદ કરો",
            back: "પાછળ",
            admin: "એડમિન",
            subAdmin: "પેટા એડમિન",
            volunteer: "કાર્યકર્તા",
            boothPramukh: "બૂથ પ્રમુખ",
            sahBoothPramukh: "સહ બૂથ પ્રમુખ",
            validMobile: "કૃપા કરીને માન્ય 10-અંકનો મોબાઇલ નંબર દાખલ કરો",
            invalidNumber: "અમાન્ય નંબર",
            serverError: "સર્વર ભૂલ",
            enterOTP: "કૃપા કરીને OTP દાખલ કરો",
            invalidOTP: "અમાન્ય OTP",
            noAccount: "આ નંબર માટે કોઈ ખાતું મળ્યું નથી.",
            verificationFailed: "ચકાસણી નિષ્ફળ",
            otpSent: "OTP સફળતાપૂર્વક મોકલાયો",
            mobileRequired: "મોબાઇલ નંબર જરૂરી છે",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)",
            warCaptain: "વોર કેપ્ટન",
            boothCaptain: "બૂથ કેપ્ટન",
            liveVottingUser: "લાઇવ વોટિંગ યુઝર",
            callSurveyUser: "કોલ સર્વે યુઝર",
            voterCaptain: "વોટર કેપ્ટન"
        }
    };

    const handelKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendOTP();
        }
    };

    const txt = t[lang];

    // --- Mobile Number Validation Functions ---
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        const limitedValue = numericValue.slice(0, 10);
        setMobile(limitedValue);

        if (mobileError) {
            setMobileError("");
        }

        if (limitedValue.length > 0) {
            const validation = validateMobileNumber(limitedValue);
            if (!validation.isValid && limitedValue.length === 10) {
                setMobileError(validation.message);
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setMobileError(txt.mobileLength);
            } else {
                setMobileError("");
            }
        }
    };

    const handleSendOTP = async () => {
        const validation = validateMobileNumber(mobile);
        if (!validation.isValid) {
            setMobileError(validation.message);
            setError(validation.message);
            return;
        }

        setLoading(true);
        setError("");

        try {
            const response = await axios.post(
                `${BASE_URL}/api/send-otp`,
                { mobile_no: mobile }
            );
            if (response.data.success) {
                setStep(2);
            } else {
                setError(response.data.message || response.data.error || txt.invalidNumber);
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.status >= 500) {
                setError(txt.serverError);
            } else {
                setError(err.response?.data?.message || err.response?.data?.error || txt.invalidNumber);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOTP = async () => {
        if (!otp) {
            setError(txt.enterOTP);
            return;
        }
        setLoading(true);
        setError("");

        try {
            const response = await axios.post(
                `${BASE_URL}/api/verify-otp`,
                { mobile_no: mobile, otp }
            );

            if (response.data.success) {
                const result = response.data.data.result;

                if (result.length === 1) {
                    loginUser(result[0]);
                } else if (result.length > 1) {
                    setUserList(result);

                    // 🔴 Group users by Ward (vidhansabha_no) exactly like ChangeResponsibility
                    const grouped = {};
                    result.forEach(user => {
                        const wardKey = user.vidhansabha_no;
                        if (!grouped[wardKey]) {
                            grouped[wardKey] = {
                                wardNo: user.vidhansabha_no,
                                wardName: user.vidhansabha_name,
                                users: []
                            };
                        }
                        grouped[wardKey].users.push(user);
                    });

                    setGroupedUsers(grouped);
                    setStep(3); // Moving to unified step 3
                } else {
                    setError(txt.noAccount);
                }
            } else {
                setError(txt.invalidOTP);
            }
        } catch (err) {
            console.error(err);
            setError(txt.verificationFailed);
        } finally {
            setLoading(false);
        }
    };

    const handelEnterDown = (e) => {
        if (e.key === "Enter") {
            handleVerifyOTP();
        }
    };

    const loginUser = (user) => {
        if (!user) return;

        // Store all user data in context
        setAppId(user.app_id);
        setUserName(user.name);
        setUserPhoto(user.photo_path || user.photo || null);
        setTotalVoters(user.total_voter);
        setUserId(user.user_id);
        setMobileNo(mobile);

        // Store vidhan sabha details
        if (setVidhanSabhaNo) setVidhanSabhaNo(user.vidhansabha_no);
        if (setVidhanSabhaName) setVidhanSabhaName(user.vidhansabha_name);

        // Store candidate details
        if (setCandidateNo) setCandidateNo(user.candidate_no);
        if (setCandidateName) setCandidateName(user.candidate_name);

        // Store party details
        if (setPartyShortName) setPartyShortName(user.party_short_name);
        if (setPartyFullName) setPartyFullName(user.party_full_name);
        if (setPartyLogoPng) setPartyLogoPng(user.party_logo_png);
        if (setPartyLogoJpg) setPartyLogoJpg(user.party_logo_jpg);

        // Store slip messages
        if (setSlipMessage) setSlipMessage(user.slip_message);
        if (setSmsSlipMessage) setSmsSlipMessage(user.sms_slip_message);

        // Store offline settings
        if (setOfflineStatus) setOfflineStatus(user.offline_status);
        if (setOfflineDbUrl) setOfflineDbUrl(user.offline_db_url);
        if (setOfflineVer) setOfflineVer(user.offline_ver);

        // Store app settings
        if (setSplaceUrl) setSplaceUrl(user.splace_url);
        if (setAppLink) setAppLink(user.app_link);
        if (setVideoLink) setVideoLink(user.video_link);
        if (setAppVer) setAppVer(user.app_ver);

        // Store user type and booth
        if (setBoothNo) setBoothNo(user.booth_no);
        if (setTempStatus) setTempStatus(user.temp_status);

        // Store popup settings
        if (setPopupStatus) setPopupStatus(user.popup_status);
        if (setPopupUrl) setPopupUrl(user.popup_url);

        // Set authentication state
        setIsAuthenticated(true);

        // Save to localStorage
        localStorage.setItem('appId', user.app_id);
        localStorage.setItem('userName', user.name);
        localStorage.setItem('userId', user.user_id);
        if (user.total_voter) localStorage.setItem('totalVoters', user.total_voter);
        if (user.photo_path || user.photo) localStorage.setItem('userPhoto', user.photo_path || user.photo);

        // Save vidhan sabha data
        localStorage.setItem('vidhanSabhaNo', user.vidhansabha_no);
        localStorage.setItem('vidhanSabhaName', user.vidhansabha_name);

        // Save candidate data
        localStorage.setItem('candidateNo', user.candidate_no);
        localStorage.setItem('candidateName', user.candidate_name);

        // Save party data
        localStorage.setItem('partyShortName', user.party_short_name);
        localStorage.setItem('partyFullName', user.party_full_name);
        localStorage.setItem('partyLogoPng', user.party_logo_png);
        localStorage.setItem('partyLogoJpg', user.party_logo_jpg);

        // Save slip messages
        localStorage.setItem('slipMessage', user.slip_message);
        localStorage.setItem('smsSlipMessage', user.sms_slip_message);

        // Save offline settings
        localStorage.setItem('offlineStatus', user.offline_status);
        localStorage.setItem('offlineDbUrl', user.offline_db_url);
        localStorage.setItem('offlineVer', user.offline_ver);

        // Save app settings
        localStorage.setItem('splaceUrl', user.splace_url || '');
        localStorage.setItem('appLink', user.app_link || '');
        localStorage.setItem('videoLink', user.video_link || '');
        localStorage.setItem('appVer', user.app_ver || '');

        // Save user type and booth
        localStorage.setItem('userType', user.user_type);
        localStorage.setItem('boothNo', user.booth_no || '');
        localStorage.setItem('tempStatus', user.temp_status || '');

        // Save popup settings
        localStorage.setItem('popupStatus', user.popup_status);
        localStorage.setItem('popupUrl', user.popup_url || '');

        // Save complete user object for reference
        localStorage.setItem('userData', JSON.stringify(user));

        // Store credential by the user id
        localStorage.setItem(`credential_${user.user_id}`, JSON.stringify(user));

        // Store new feature toggle states
        if (setCallCenter) setCallCenter(user.call_center);
        if (setPrachar) setPrachar(user.prachar);
        if (setAacharSahita) setAacharSahita(user.aachar_sahita);
        if (setLiveVoting) setLiveVoting(user.live_voting);
        if (setSleepSend) setSleepSend(user.sleep_send);
        if (setMetaWtsp) setMetaWtsp(user.meta_wtsp);
        if (setWhtspApi) setWhtspApi(user.whtsp_api);
        if (setAi) setAi(user.AI);
        if (setAppClose) setAppClose(user.app_close);
        if (setWtspDeviceId) setWtspDeviceId(user.wtsp_device_id);

        // Save to localStorage
        localStorage.setItem('callCenter', user.call_center);
        localStorage.setItem('prachar', user.prachar);
        localStorage.setItem('aacharSahita', user.aachar_sahita);
        localStorage.setItem('liveVoting', user.live_voting);
        localStorage.setItem('sleepSend', user.sleep_send);
        localStorage.setItem('metaWtsp', user.meta_wtsp);
        localStorage.setItem('whtspApi', user.whtsp_api);
        localStorage.setItem('ai', user.AI);
        localStorage.setItem('appClose', user.app_close);
        if (user.wtsp_device_id) localStorage.setItem('wtspDeviceId', user.wtsp_device_id);


        navigate("/");
    };

    const getUserTypeLabel = (type) => {
        const map = {
            'A': txt.admin,
            'SA': txt.subAdmin,
            'sa': txt.subAdmin,
            'K': txt.volunteer,
            'k': txt.volunteer,
            'BP': txt.boothPramukh,
            'BS': txt.sahBoothPramukh,
            'SP': "Shakti Kendra Pramukh",
            'WP': txt.warCaptain,
            'BC': txt.boothCaptain,
            'LV': txt.liveVottingUser,
            'CL': txt.callSurveyUser,
            'VC': txt.voterCaptain
        };
        return map[type] || type || 'User';
    };

    return (
        <div className="login-container">
            {/* Background Pattern */}
            <div className="background-pattern">
                <div className="pattern-dots"></div>
                <div className="glow-orb glow-orb-1"></div>
                <div className="glow-orb glow-orb-2"></div>
            </div>

            <div className="login-wrapper">
                {/* Left Side - Minimalist Brand */}
                <div className="brand-section">
                    <div className="brand-mesh"></div>
                    {/* 🔴 FIX: sticky wrapper keeps logo nicely positioned even when this
                        column stretches taller (e.g. Step 3 profile list) */}
                    <div className="brand-sticky-wrap">
                        <div className="brand-content">
                            <div className="brand-icon">
                                <img src='https://maharashtra.bjpwings.com/img/admin/09022026022058_1770632573055.jpg' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} alt="BJP Logo" />
                            </div>
                            <h1 className="brand-name">BJP<br />Wings</h1>
                            <div className="brand-divider"></div>
                            <p className="brand-tagline">Empowering Every Booth,<br />Every Voter, Every Vote.</p>
                            <div className="brand-year"></div>
                        </div>
                    </div>
                </div>

                {/* Right Side - Login Form */}
                <div className={`login-section ${step >= 3 ? 'wide-section' : ''}`}>

                    {/* Header */}
                    <div className="login-header m-1">
                        <div className="step-indicator">
                            <span className={`step-dot ${step >= 1 ? 'active' : ''}`}></span>
                            <span className={`step-dot ${step >= 2 ? 'active' : ''}`}></span>
                            <span className={`step-dot ${step >= 3 ? 'active' : ''}`}></span>
                        </div>
                        <h2 className="login-title">
                            {step === 1 && txt.login}
                            {step === 2 && "Verification"}
                            {step === 3 && "Choose Profile"}
                        </h2>
                        {step === 1 && <p className="login-subtitle">{txt.enterMobile}</p>}
                        {step === 2 && <p className="login-subtitle">{txt.enterCode.replace('{mobile}', mobile)}</p>}
                    </div>

                    {/* STEP 1: Mobile Input */}
                    {step === 1 && (
                        <div className="form-container">
                            <div className="input-group">
                                <label className="input-label">{txt.mobileNumber}</label>
                                <div className={`phone-input ${mobileError ? 'error' : ''}`}>
                                    <span className="country-code">+91</span>
                                    <div className="input-divider"></div>
                                    <input
                                        type="tel"
                                        className="input-field"
                                        placeholder={txt.mobilePlaceholder}
                                        value={mobile}
                                        onChange={handleMobileChange}
                                        maxLength={10}
                                        onKeyDown={handelKeyDown}
                                    />
                                </div>
                                {mobileError && (
                                    <div className="mobile-error-message">
                                        <span className="error-icon-small">⚠️</span>
                                        <span>{mobileError}</span>
                                    </div>
                                )}
                            </div>

                            <button
                                className="login-btn"
                                onClick={handleSendOTP}
                                disabled={loading || !mobile || mobile.length !== 10 || mobileError}
                            >
                                <span className="btn-content">
                                    {loading ? (
                                        <div className="loader"></div>
                                    ) : txt.sendOTP}
                                </span>
                            </button>
                        </div>
                    )}

                    {/* STEP 2: OTP Input */}
                    {step === 2 && (
                        <div className="form-container">
                            <div className="otp-section">
                                <div className="otp-inputs">
                                    {Array.from({ length: 6 }).map((_, index) => (
                                        <div
                                            key={index}
                                            className={`otp-digit ${otp[index] ? 'filled' : ''} ${otp.length === index ? 'active-digit' : ''}`}
                                        >
                                            {otp[index] || ''}
                                        </div>
                                    ))}
                                </div>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={otp}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setOtp(value.slice(0, 6));
                                    }}
                                    autoFocus
                                    className="otp-hidden-input"
                                    onKeyDown={handelEnterDown}
                                />
                            </div>

                            <button
                                className="login-btn"
                                onClick={handleVerifyOTP}
                                disabled={loading || otp.length !== 6}
                            >
                                <span className="btn-content">
                                    {loading ? (
                                        <div className="loader"></div>
                                    ) : txt.verifyLogin}
                                </span>
                            </button>

                            <button className="change-link" onClick={() => { setStep(1); setOtp(""); setError(""); setMobileError(""); }}>
                                ← {txt.changeNumber}
                            </button>
                        </div>
                    )}

                    {/* STEP 3: Unified Ward & Profile Selection */}
                    {step === 3 && (
                        <div className="selection-container p-0 m-0">
                            

                            <div className="list-scroller-wrapper" style={{ maxHeight: '350px', overflowY: 'auto', paddingRight: '8px' }}>
                                <div className="list-scroller-content" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                    {Object.values(groupedUsers).map((wardGroup) => (
                                        <div key={`ward-${wardGroup.wardNo}`} className="ward-group-container">
                                            {/* Ward Section Header */}
                                            <div className="ward-section-header" style={{ display: 'flex', alignItems: 'center', gap: '12px', paddingBottom: '8px', borderBottom: '2px solid #e2e8f0', marginBottom: '12px' }}>
                                                <div className="ward-badge-pill" style={{ background: '#e0e7ff', color: '#3730a3', fontSize: '12px', fontWeight: '700', padding: '4px 12px', borderRadius: '50px', border: '1px solid #c7d2fe' }}>
                                                    {wardGroup.wardNo}
                                                </div>
                                                <span className="ward-section-name text-truncate" style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b' }}>
                                                    {wardGroup.wardName ? (wardGroup.wardName.includes('Municipal') ? wardGroup.wardName : `${wardGroup.wardName}`) : ''}
                                                </span>
                                            </div>

                                            {/* Users under this Ward */}
                                            <div className="profile-list" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                {wardGroup.users.map((user) => (
                                                    <button
                                                        key={user.user_id}
                                                        className={`profile-card ${finalUser?.user_id === user.user_id ? 'selected' : ''}`}
                                                        onClick={() => setFinalUser(user)}
                                                    >
                                                        <div className="profile-avatar">
                                                            {user.photo_path ? (
                                                                <img src={user.photo_path} alt={user.name} />
                                                            ) : (
                                                                <span className="avatar-initials">{user.name?.charAt(0) || 'U'}</span>
                                                            )}
                                                        </div>

                                                        <div className="profile-info">
                                                            <div className="profile-header-info">
                                                                <span className="profile-name text-truncate">{user.name}</span>
                                                                <span className={`role-badge-small ${user.user_type === 'A' ? 'admin-badge' : 'sub-admin-badge'}`}>
                                                                    {getUserTypeLabel(user.user_type)}
                                                                </span>
                                                            </div>
                                                            {user.booth_no && (
                                                                <span className="profile-user-name">Booth: {user.booth_no}</span>
                                                            )}
                                                        </div>

                                                        {finalUser?.user_id === user.user_id && (
                                                            <div className="check-mark">
                                                                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <button
                                className="login-btn mt-4"
                                onClick={() => loginUser(finalUser)}
                                disabled={!finalUser}
                            >
                                <span className="btn-content">{txt.login}</span>
                            </button>
                        </div>
                    )}

                    {/* Error Message */}
                    {error && (
                        <div className="error-toast">
                            <span className="error-icon">!</span>
                            <span className="error-text">{error}</span>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                * {
                    box-sizing: border-box;
                }

                .login-container {
                    min-height: 100vh;
                    background: #f8fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    position: relative;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                    overflow: hidden;
                }

                .background-pattern {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    pointer-events: none;
                    overflow: hidden;
                }

                .pattern-dots {
                    width: 100%;
                    height: 100%;
                    background-image: radial-gradient(#cbd5e1 1px, transparent 1px);
                    background-size: 32px 32px;
                    opacity: 0.4;
                }

                .glow-orb {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(80px);
                    opacity: 0.25;
                    animation: float 10s ease-in-out infinite;
                }

                .glow-orb-1 {
                    width: 400px;
                    height: 400px;
                    background: radial-gradient(circle, #2563EB, transparent 70%);
                    top: -100px;
                    left: -100px;
                }

                .glow-orb-2 {
                    width: 350px;
                    height: 350px;
                    background: radial-gradient(circle, #111827, transparent 70%);
                    bottom: -120px;
                    right: -120px;
                    animation-delay: -5s;
                }

                @keyframes float {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    50% { transform: translate(30px, 20px) scale(1.05); }
                }

                .login-wrapper {
                    display: flex;
                    width: 100%;
                    max-width: 920px;
                    background: #ffffff;
                    border-radius: 28px;
                    overflow: hidden;
                    position: relative;
                    z-index: 1;
                    box-shadow: 
                        0 32px 64px -12px rgba(15, 23, 42, 0.2), 
                        0 12px 24px -8px rgba(15, 23, 42, 0.08),
                        0 0 0 1px rgba(255, 255, 255, 0.5) inset;
                    animation: wrapperEntrance 0.6s cubic-bezier(0.16, 1, 0.3, 1);
                }

                @keyframes wrapperEntrance {
                    from { opacity: 0; transform: translateY(24px) scale(0.98); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                /* Left Brand Section */
                .brand-section {
                    width: 330px;
                    background: linear-gradient(160deg, #111827 0%, #1e293b 100%);
                    display: flex;
                    align-items: stretch;
                    justify-content: center;
                    padding: 0 32px;
                    position: relative;
                    overflow: hidden;
                }

                .brand-mesh {
                    position: absolute;
                    inset: 0;
                    background: 
                        radial-gradient(circle at 20% 20%, rgba(37, 99, 235, 0.25) 0%, transparent 50%),
                        radial-gradient(circle at 80% 80%, rgba(37, 99, 235, 0.15) 0%, transparent 50%);
                    pointer-events: none;
                }

                .brand-section::after {
                    content: '';
                    position: absolute;
                    width: 200%;
                    height: 200%;
                    background: radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 60%);
                    top: -50%;
                    left: -50%;
                }

                /* 🔴 FIX: Sticky wrapper — keeps the logo/brand block visually
                   centered within the visible viewport area instead of being
                   stretched/centered inside an unusually tall column (Step 3). */
                .brand-sticky-wrap {
                    position: sticky;
                    top: 0;
                    align-self: flex-start;
                    width: 100%;
                    min-height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 48px 0;
                }

                .brand-content {
                    text-align: center;
                    position: relative;
                    z-index: 2;
                }

                .brand-icon {
                    width: 92px;
                    height: 92px;
                    margin: 0 auto 24px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.15);
                    padding: 4px;
                    box-shadow: 
                        0 12px 24px rgba(0, 0, 0, 0.25),
                        0 0 0 1px rgba(255, 255, 255, 0.1),
                        0 0 0 6px rgba(255, 255, 255, 0.04);
                    transition: transform 0.3s ease;
                }

                .brand-name {
                    color: white;
                    font-size: 32px;
                    font-weight: 800;
                    line-height: 1.15;
                    margin: 0 0 20px;
                    letter-spacing: 0.5px;
                    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
                }

                .brand-divider {
                    width: 40px;
                    height: 3px;
                    background: linear-gradient(90deg, #2563EB, #60a5fa);
                    margin: 0 auto 20px;
                    border-radius: 4px;
                }

                .brand-tagline {
                    color: rgba(255, 255, 255, 0.55);
                    font-size: 13px;
                    line-height: 1.6;
                    font-weight: 500;
                    letter-spacing: 0.2px;
                    margin: 0;
                }

                /* Right Login Section */
                .login-section {
                    flex: 1;
                    padding: 56px 64px;
                    background: white;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    position: relative;
                }

                .wide-section {
                    max-width: 590px;
                }

                /* Header */
                .login-header {
                    margin-bottom: 36px;
                }

                .step-indicator {
                    display: flex;
                    gap: 6px;
                    margin-bottom: 20px;
                }

                .step-dot {
                    width: 24px;
                    height: 4px;
                    border-radius: 4px;
                    background: #e2e8f0;
                    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
                }

                .step-dot.active {
                    background: linear-gradient(90deg, #2563EB, #3b82f6);
                    width: 32px;
                    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
                }

                .login-title {
                    font-size: 32px;
                    font-weight: 800;
                    color: #0f172a;
                    margin: 0 0 12px;
                    letter-spacing: -0.6px;
                    animation: fadeSlideIn 0.4s ease;
                }

                .login-subtitle {
                    color: #64748b;
                    font-size: 15px;
                    margin: 0;
                    line-height: 1.5;
                    font-weight: 500;
                    animation: fadeSlideIn 0.5s ease;
                }

                @keyframes fadeSlideIn {
                    from { opacity: 0; transform: translateY(-6px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                /* Form Container */
                .form-container {
                    max-width: 360px;
                    animation: fadeSlideIn 0.4s ease;
                }

                /* Input Group */
                .input-group {
                    margin-bottom: 32px;
                }

                .input-label {
                    display: block;
                    font-size: 13px;
                    font-weight: 700;
                    color: #475569;
                    margin-bottom: 10px;
                    letter-spacing: 0.2px;
                    text-transform: uppercase;
                    font-size: 11px;
                }

                .phone-input {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    background: #f8fafc;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 14px;
                    padding: 4px 18px;
                    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                }

                .phone-input.error {
                    border-color: #ef4444;
                    background: #fffbfb;
                }

                .phone-input.error:focus-within {
                    border-color: #ef4444;
                    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
                }

                .phone-input:hover:not(:focus-within) {
                    border-color: #cbd5e1;
                }

                .phone-input:focus-within {
                    background: #ffffff;
                    border-color: #2563EB;
                    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 4px 12px rgba(37, 99, 235, 0.08);
                }

                .country-code {
                    color: #0f172a;
                    font-size: 16px;
                    font-weight: 700;
                }

                .input-divider {
                    width: 1px;
                    height: 24px;
                    background: #cbd5e1;
                    margin: 0 14px;
                }

                .input-field {
                    flex: 1;
                    padding: 15px 0;
                    border: none;
                    outline: none;
                    font-size: 16px;
                    font-weight: 600;
                    color: #0f172a;
                    background: transparent;
                    letter-spacing: 1px;
                }
                
                .input-field::placeholder {
                    color: #94a3b8;
                    font-weight: 400;
                    letter-spacing: normal;
                }

                .mobile-error-message {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 10px;
                    font-size: 12px;
                    color: #ef4444;
                    background: #fef2f2;
                    padding: 9px 12px;
                    border-radius: 10px;
                    font-weight: 500;
                    animation: fadeSlideIn 0.3s ease;
                }

                .error-icon-small {
                    font-size: 12px;
                }

                /* OTP Section */
                .otp-section {
                    margin-bottom: 36px;
                    position: relative;
                }

                .otp-inputs {
                    display: flex;
                    gap: 12px;
                    justify-content: flex-start;
                }

                .otp-digit {
                    width: 44px;
                    height: 54px;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 14px;
                    background: #f8fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 21px;
                    font-weight: 700;
                    color: #0f172a;
                    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                }

                .otp-digit.filled {
                    background: #eff6ff;
                    border-color: #2563eb;
                    color: #2563eb;
                    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.12);
                    transform: scale(1.02);
                }

                .otp-digit.active-digit {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
                    background: #ffffff;
                }

                .otp-hidden-input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    cursor: pointer;
                    letter-spacing: 30px; 
                }

                /* Selection Container */
                .selection-container {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    animation: fadeSlideIn 0.4s ease;
                }

                /* Profile Card Styles for Step 3 */
                .profile-list {
                    display: flex; flex-direction: column; gap: 10px;
                }

                .profile-card {
                    display: flex; align-items: center; padding: 14px 16px;
                    border: 1.5px solid #e2e8f0; border-radius: 14px; 
                    background: #ffffff; 
                    box-shadow: 0 1px 3px rgba(0,0,0,0.02); 
                    cursor: pointer; transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                    text-align: left;
                    width: 100%;
                }
                .profile-card:hover { 
                    border-color: #93c5fd; 
                    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.1);
                    transform: translateY(-2px);
                }
                .profile-card.selected {
                    background: linear-gradient(135deg, #eff6ff, #f0f7ff); 
                    border: 1.5px solid #3b82f6;
                    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.18);
                }

                .profile-avatar {
                    width: 46px; height: 46px; border-radius: 50%;
                    background: #f1f5f9; border: 1.5px solid #e2e8f0;
                    display: flex; align-items: center; justify-content: center;
                    margin-right: 16px; flex-shrink: 0; overflow: hidden;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
                }
                .profile-avatar img { width: 100%; height: 100%; object-fit: cover; }
                .avatar-initials { font-size: 18px; font-weight: 800; color: #0f172a; text-transform: uppercase; }

                .profile-info { flex: 1; min-width: 0; }
                .profile-header-info { display: flex; align-items: center; gap: 10px; margin-bottom: 4px; }
                .profile-name { font-size: 15px; font-weight: 700; color: #0f172a; }

                .role-badge-small {
                    font-size: 10px; font-weight: 700; padding: 3px 9px;
                    border-radius: 6px; text-transform: uppercase; white-space: nowrap;
                    letter-spacing: 0.3px;
                }
                .admin-badge { background: #e2e8f0; color: #475569; }
                .sub-admin-badge { background: #e0e7ff; color: #1d4ed8; }

                .profile-user-name { display: block; font-size: 12px; color: #64748b; font-weight: 600; }

                .check-mark {
                    width: 26px; height: 26px; border-radius: 50%; 
                    background: linear-gradient(135deg, #3b82f6, #2563eb); color: white;
                    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
                    box-shadow: 0 3px 8px rgba(37, 99, 235, 0.35);
                    animation: popIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
                }

                @keyframes popIn {
                    from { transform: scale(0); opacity: 0; }
                    to { transform: scale(1); opacity: 1; }
                }

                /* Scrollbar Formatting */
                .list-scroller-wrapper::-webkit-scrollbar { width: 6px; }
                .list-scroller-wrapper::-webkit-scrollbar-track { background: transparent; }
                .list-scroller-wrapper::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
                .list-scroller-wrapper::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

                /* Login Button */
                .login-btn {
                    width: 100%;
                    padding: 17px;
                    background: linear-gradient(135deg, #2563EB, #1d4ed8);
                    color: white;
                    border: none;
                    border-radius: 16px;
                    font-size: 15px;
                    font-weight: 700;
                    letter-spacing: 0.4px;
                    cursor: pointer;
                    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 16px -4px rgba(37, 99, 235, 0.35);
                    position: relative;
                    overflow: hidden;
                }

                .btn-content {
                    position: relative;
                    z-index: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .login-btn::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
                    transition: left 0.6s ease;
                }

                .login-btn:hover:not(:disabled)::before {
                    left: 100%;
                }

                .login-btn:hover:not(:disabled) {
                    background: linear-gradient(135deg, #1d4ed8, #1e40af);
                    transform: translateY(-2px);
                    box-shadow: 0 10px 22px -4px rgba(37, 99, 235, 0.45);
                }

                .login-btn:active:not(:disabled) {
                    transform: translateY(0);
                }

                .login-btn:disabled {
                    opacity: 0.45;
                    cursor: not-allowed;
                    transform: none;
                    box-shadow: none;
                }

                /* Change Link */
                .change-link {
                    background: none;
                    border: none;
                    color: #64748b;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    padding: 22px 0 0;
                    width: 100%;
                    transition: all 0.2s ease;
                }

                .change-link:hover {
                    color: #2563EB;
                }

                /* Loader */
                .loader {
                    width: 20px;
                    height: 20px;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                    border-radius: 50%;
                    border-top-color: white;
                    animation: spin 0.8s linear infinite;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                /* Error Toast */
                .error-toast {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 13px 16px;
                    background: #fef2f2;
                    border: 1.5px solid #fecaca;
                    border-radius: 14px;
                    margin-top: 24px;
                    animation: slideUp 0.3s ease;
                    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.08);
                }
                
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .error-icon {
                    width: 24px;
                    height: 24px;
                    background: #ef4444;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    font-weight: bold;
                    flex-shrink: 0;
                }

                .error-text {
                    color: #991b1b;
                    font-size: 14px;
                    font-weight: 600;
                }

                /* Responsive Design */
                @media (max-width: 768px) {
                    .login-wrapper {
                        flex-direction: column;
                        max-width: 500px;
                        width: 100%;
                        border-radius: 24px;
                    }

                    .brand-section {
                        width: 100%;
                        padding: 0 30px;
                    }

                    /* 🔴 FIX: disable sticky trick on stacked mobile layout,
                       revert to normal centered block */
                    .brand-sticky-wrap {
                        position: static;
                        padding: 24px 0;
                        min-height: auto;
                    }

                    .brand-tagline {
                        display: none;
                    }

                    .brand-divider {
                        display: none;
                    }
                    
                    .form-container {
                        max-width: none;
                    }

                    .brand-content {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        gap: 16px;
                        text-align: left;
                    }

                    .brand-icon {
                        width: 56px;
                        height: 56px;
                        margin: 0;
                    }

                    .brand-name {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 24px;
                        margin: 0;
                        line-height: 1.1;
                    }

                    .brand-name br {
                        display: none;
                    }

                    .login-section {
                        padding: 40px 32px;
                    }

                    .login-title {
                        font-size: 28px;
                    }
                }

                @media (max-width: 480px) {
                    .login-container {
                        padding: 16px;
                    }

                    .login-wrapper {
                        border-radius: 20px;
                    }

                    .brand-section {
                        padding: 0 16px;
                    }

                    .brand-sticky-wrap {
                        padding: 20px 0;
                    }

                    .login-section {
                        padding: 24px 16px;
                    }

                    .form-container {
                        max-width: 100%;
                    }

                    .otp-inputs {
                        gap: 6px; 
                    }

                    .otp-digit {
                        flex: 1;
                        max-width: 36px;
                        height: 46px; 
                        font-size: 18px;
                        border-radius: 10px;
                    }   
                    
                    .login-title {
                        font-size: 24px;
                    }

                    .mobile-error-message {
                        font-size: 10px;
                        padding: 6px 10px;
                    }
                    
                    /* Adjusting scroller height for mobile */
                    .list-scroller-wrapper {
                        max-height: 280px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default LoginWithOTP;